(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["CuonHero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.cuoProofHeroMouseFollowReady) return;
    window.cuoProofHeroMouseFollowReady = true;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function bindHero(hero) {
      if (!hero || hero.dataset.cuoProofMouseBound === 'true') return;
      hero.dataset.cuoProofMouseBound = 'true';

      hero.addEventListener('pointermove', function (event) {
        var rect = hero.getBoundingClientRect();
        if (!rect.width || !rect.height) return;

        var x = clamp(((event.clientX - rect.left) / rect.width) * 100, 0, 100);
        var y = clamp(((event.clientY - rect.top) / rect.height) * 100, 0, 100);
        var shiftX = (x - 50) * -0.08;
        var shiftY = (y - 50) * -0.055;

        hero.style.setProperty('--cuo-proof-pointer-x', x.toFixed(2) + '%');
        hero.style.setProperty('--cuo-proof-pointer-y', y.toFixed(2) + '%');
        hero.style.setProperty('--cuo-proof-shift-x', shiftX.toFixed(2) + 'px');
        hero.style.setProperty('--cuo-proof-shift-y', shiftY.toFixed(2) + 'px');
      });

      hero.addEventListener('pointerleave', function () {
        hero.style.setProperty('--cuo-proof-pointer-x', '50%');
        hero.style.setProperty('--cuo-proof-pointer-y', '50%');
        hero.style.setProperty('--cuo-proof-shift-x', '0px');
        hero.style.setProperty('--cuo-proof-shift-y', '0px');
      });
    }

    function bindAll(root) {
      var scope = root || document;
      var heroes = scope.querySelectorAll ? scope.querySelectorAll('.cuo-proof-hero') : [];
      heroes.forEach(bindHero);
    }

    bindAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      bindAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
